import Dashboard from "views/Dashboard.js";
// import Icons from "views/Icons.js";
import About from "views/About.js";

let routes = [
  {
    path: "/home",
    name: "Home",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
  },
  {
    path: "/about-us",
    name: "About Us",
    icon: "tim-icons icon-single-02",
    component: About,
  },
];
export default routes;
